












import {Component, Vue, Prop} from "vue-property-decorator";

@Component({
    name: "AgoraDeviceTestStart"
})
export default class AgoraDeviceTestStart extends Vue {
    @Prop({ default: false }) startButtonExist: boolean;
}
